module.exports = __webpack_public_path__ + "img/close-small-black.21d92832.svg";